"use client";

import usePermissionStore from "@/stores/usePermissionStore";
import useCouponsStudents from "@/stores/useCouponsStudents";
import { Top, List as ListAdmins } from "@/components/permisos";

interface PermissionProps {
  companyAdmins: StudentsInfoType;
  companyId?: number;
  couponsPermission?: boolean;
  urlAfterActivatingAdmin: string;
}

export const Permission = ({
  companyAdmins,
  companyId,
  urlAfterActivatingAdmin,
  couponsPermission = false,
}: PermissionProps) => {
  const setAdmins = usePermissionStore((state) => state.setAdmins);
  const setUrlAfterActivatingAdmin = usePermissionStore((state) => state.setUrlAfterActivatingAdmin);
  const setCompanyId = useCouponsStudents((state) => state.setCompanyId);
  const setCouponsPermission = useCouponsStudents((state) => state.setCouponsPermission);

  setAdmins(companyAdmins?.data);
  setUrlAfterActivatingAdmin(urlAfterActivatingAdmin);
  setCompanyId(companyId);
  setCouponsPermission(couponsPermission);

  return (
    <>
      <Top />
      <ListAdmins />
    </>
  );
};
